export default {
  visa: '在留資格管理',
  employee: '従業員管理',
  download: 'ダウンロード中心',
  settings: '設定',

  // Data Summary routes
  dataSummary: 'ダッシュボード',
  dataOverview: 'データ概要',
  headhunterBoard: 'エージェント推薦',
  internalBoard: '自社応募',
  myBoard: 'myダッシュボード',

  // Job routes
  jobMananger: '採用管理',
  job: '求人管理',
  jobForm: '求人作成',
  jobFormEdit: '職位編集',
  jobDetail: '求人詳細',
  agentManage: 'エージェント管理',
  agentJobList: '求人管理',
  businessManage: '募集企業',

  // Headhunter Chat
  headhunterChat: 'メッセンジャー',
  companyChat: 'メッセンジャー',
  // Candidate routes
  candidate: '候補者管理',
  candidateSelecting: '全選考リスト',
  candidateRegistered: '自社候補者リスト',
  candidateEdit: '候補者登録',
  candidateDetail: '候補者詳細',
  candidateSelectingDetail: '選考詳細',

  // Settings routes
  account: 'アカウント管理',
  accountDetail: '個人情報',
  companySetting: '企業情報',
  departmentSetting: '勤務先管理',
  interviewSetting: '選考設定',
  interviewProcess: '選考フロー',
  interviewProcessDetail: '選考フロー詳細',
  interviewChannel: '応募チャンネル',
  notify: '通知一覧',
  notifySettings: '消息設置',

  // Error pages
  error404: '404',
  error403: '403',
};
